import { render, staticRenderFns } from "./manageProducts.vue?vue&type=template&id=513a0be2&scoped=true&"
import script from "./manageProducts.vue?vue&type=script&lang=js&"
export * from "./manageProducts.vue?vue&type=script&lang=js&"
import style0 from "./manageProducts.vue?vue&type=style&index=0&id=513a0be2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513a0be2",
  null
  
)

export default component.exports